import isEqual from "lodash/isEqual";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import sortBy from "lodash/sortBy";

const normalize = (value: Record<string, any>): any => {
  if (isArray(value)) {
    return sortBy(value, (v) => JSON.stringify(v));
  }
  if (isObject(value) && value !== null) {
    const result: Record<string, any> = {};
    for (const key of Object.keys(value).sort()) {
      result[key] = normalize(value[key]);
    }
    return result;
  }
  return value;
};

/**
 * Compares two objects deeply, safe against null/undefined.
 */
export const compareObjectsSafe = (
  obj1?: Record<string, any> | null,
  obj2?: Record<string, any> | null,
): { isEqual: boolean; changedKeys: string[] } => {
  if (!obj1 && !obj2) {
    return { isEqual: true, changedKeys: [] };
  }

  if (!obj1 || !obj2) {
    const keys = Object.keys(obj1 || obj2 || {});
    return { isEqual: false, changedKeys: keys };
  }

  const allKeys = Array.from(new Set([...Object.keys(obj1), ...Object.keys(obj2)]));
  const changedKeys = allKeys.filter((key) => {
    const val1 = normalize(obj1[key]);
    const val2 = normalize(obj2[key]);
    return !isEqual(val1, val2);
  });

  return {
    isEqual: changedKeys.length === 0,
    changedKeys,
  };
};
